import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@fluentui/react/lib/Icon'
import { ChevronLeft, ChevronRight } from 'react-feather'

const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const data = [
  {
    year: '2007',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sit aliqua ',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sit aliqua'
    },
  },
  {
    year: '2009',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sitExercitation veniam consequat sunt nostrud amet.',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sitExercitation veniam consequat sunt nostrud amet.'
    },
  },
  {
    year: '2011',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. ',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. '
    },
  },
  {
    year: '2014',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. ',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. '
    },
  },
  {
    year: '2016',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. ',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. '
    },
  },
  {
    year: '2017',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. ',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. '
    },
  },
  {
    year: '2018',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. ',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. '
    },
  },
  {
    year: '2019',
    description: {
      en: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. ',
      id: 'Bahasa Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. '
    },
  },
]

const MilestoneRow = ({data}) => {
  const [open, setOpen] = React.useState(false)

  const actionButtonClasses = "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5"
  const actionButtonStyles = {
    minWidth: '67px'
  }

  return (
    <tr className="text-sm text-gray-444">
      <td className="align-top">
        <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Year</div>
        {data.year}
      </td>
      <td>
        <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Description</div>
        <div className="mb-4 font-bold hidden lg:block">
          {data.description.en}
        </div>
        <div className="">
          {data.description.id}
        </div>
      </td>
      <td className="relative">
        <div className="hidden lg:flex items-center">
          <p className="cursor-pointer underline text-sm text-gray-444 mr-8">
            <Link to="/dashboard/profile/milestones/edit">Edit</Link>
          </p>
          <p className="cursor-pointer underline text-sm text-gray-999">Delete</p>
        </div>

        <ChevronLeft className="lg:hidden" onClick={() => setOpen(true)}/>
        {
          open &&
          <div className="flex items-center absolute top-0 right-0 h-full">
            <div
              className="h-full flex items-center justify-end pr-4"
              style={{width: '183px', background: 'linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)'}}
              onClick={() => setOpen(false)}
            >
              <ChevronRight />
            </div>
            <Link
              className={`bg-primary ${actionButtonClasses}`}
              style={{...actionButtonStyles}}
              to="/dashboard/profile/milestones/edit"
            >
              <Edit/>
              <p className="underline mt-2">Edit</p>
            </Link>
            <div
              className={`${actionButtonClasses}`}
              style={{background: '#999', ...actionButtonStyles}}
            >
              <Delete/>
              <p className="underline mt-2">Delete</p>
            </div>
          </div>
        }
      </td>
    </tr>
  )
}

const MilestoneTable = () => {
  return (
    <table className="table table--striped">
      <thead className="hidden lg:table-header-group">
        <tr className="text-xs">
          <th width="18%">Year</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          data.map((d, index) => (
            <MilestoneRow key={index} data={d}/>
          ))
        }
      </tbody>
    </table>
  )
}

export { MilestoneTable }